import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import QuoteModal from '../common/QuoteModal';

const ServicesCTA = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  
  // Background image path - easily customizable
  const backgroundImage = '/images/hero-background2.jpeg';

  return (
    <>
      <section 
        className="relative bg-cover bg-center bg-no-repeat text-white py-20"
        style={{
          backgroundImage: `url(${backgroundImage})`
        }}
      >
        {/* Blue gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-catalina-blue/90 to-san-marino/90"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Get Started?</h2>
          <p className="text-xl mb-8 text-gray-200 max-w-3xl mx-auto">
            Contact us today to discuss your material handling needs and discover how our solutions can transform your operations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => setIsQuoteModalOpen(true)}
              className="bg-tango text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-orange-600 transition duration-300 inline-block"
            >
              Request Quote
            </button>
            <Link
              to="/contact"
              className="bg-white text-catalina-blue px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-100 transition duration-300 inline-block"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </>
  );
};

export default ServicesCTA;